import { render, staticRenderFns } from "./vendors-active.vue?vue&type=template&id=7eca1dde&scoped=true"
import script from "./vendors-active.vue?vue&type=script&lang=js"
export * from "./vendors-active.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eca1dde",
  null
  
)

export default component.exports